import React from "react";
import { Box, BoxProps, Text } from "@chakra-ui/react";
import { KICKER_STYLE, useIndustry } from "./tokens";

interface KickerProps extends BoxProps {
  /** Reversed palette for steel fields: accent-200 text, accent-800 rule. */
  onSteel?: boolean;
  /** Omit the 1px rule (for inline meta kickers). */
  noRule?: boolean;
  children: React.ReactNode;
}

/** Kicker + rule: opens every section (handoff/README.md rule 5). */
export const Kicker: React.FC<KickerProps> = ({ onSteel = false, noRule = false, children, ...rest }) => {
  const t = useIndustry();
  return (
    <Box {...rest}>
      <Text as="div" {...KICKER_STYLE} color={onSteel ? t.accent200 : t.accent700} mb={noRule ? 0 : "12px"}>
        {children}
      </Text>
      {!noRule && <Box h="1px" bg={onSteel ? t.steelRule : t.rule} />}
    </Box>
  );
};
